// assets/sticky-atc.js
(function () {
  /* ----------------------------------------
   * Wire sticky Add to cart / Buy now buttons
   * ---------------------------------------- */
  function wireButtons() {
    var sticky = document.getElementById('StickyATC');
    if (!sticky) return;

    // Main product form (Dawn or similar)
    var productForm =
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!productForm) {
      console.warn('[StickyATC] Product form not found');
      return;
    }

    // Page’s native buttons
    var mainAddBtn =
      productForm.querySelector('button[name="add"]') ||
      productForm.querySelector('button[type="submit"]');

    // Shopify dynamic checkout button (if enabled)
    var mainBuyBtn =
      productForm.querySelector('.shopify-payment-button__button') ||
      productForm.querySelector('.shopify-payment-button button');

    // Sticky buttons
    var stickyAdd = document.getElementById('StickyATCAdd');
    var stickyBuy = document.getElementById('StickyATCBuy');

    /* ---------- Sticky Add to cart ---------- */
    if (stickyAdd && mainAddBtn) {
      stickyAdd.addEventListener('click', function () {
        mainAddBtn.click();
      });
    }

    /* ---------- Sticky Buy now ---------- */
    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        if (mainBuyBtn) {
          // Use Shopify's real dynamic checkout button if present
          mainBuyBtn.click();
        } else {
          // Fallback: submit the product form and go straight to checkout
          var returnTo = productForm.querySelector('input[name="return_to"]');
          if (!returnTo) {
            returnTo = document.createElement('input');
            returnTo.type = 'hidden';
            returnTo.name = 'return_to';
            productForm.appendChild(returnTo);
          }
          returnTo.value = '/checkout';
          productForm.submit();
        }
      });
    }
  }

  /* ----------------------------------------
   * Keep sticky price in sync with main price
   * ---------------------------------------- */
  function syncPrice() {
    var stickyPrice = document.getElementById('StickyATCPrice');
    if (!stickyPrice) return;

    // Dawn main price: <div id="price-{{ section.id }}" role="status">
    var sourcePrice = document.querySelector('div[id^="price-"][role="status"]');

    if (!sourcePrice) {
      console.warn('[StickyATC] Source price element not found');
      return;
    }

    function copy() {
      stickyPrice.innerHTML = sourcePrice.innerHTML;
    }

    // Initial copy
    copy();

    // React to DOM changes (variant changes, discounts etc.)
    var observer = new MutationObserver(copy);
    observer.observe(sourcePrice, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // Extra safety: listen to Dawn’s custom event
    document.addEventListener('variant:changed', copy);
  }

  /* ----------------------------------------
   * Keep sticky thumbnail in sync with main image
   * ---------------------------------------- */
  function syncThumb() {
    var thumb = document.getElementById('StickyATCThumb');
    if (!thumb) return;

    function update() {
      var mainImg =
        document.querySelector('.product__media-item--active img') ||
        document.querySelector('.product__media-item.is-active img') ||
        document.querySelector('.product__media img') ||
        document.querySelector('.product__media-list img');

      if (!mainImg) return;

      var src = mainImg.currentSrc || mainImg.src;
      if (!src) return;

      thumb.src = src;
      thumb.alt = mainImg.alt || thumb.alt;
      thumb.style.display = 'block';
    }

    // Initial sync
    update();

    // Watch the media wrapper for changes
    var mediaWrapper =
      document.querySelector('.product__media-wrapper') ||
      document.querySelector('.product__media-list') ||
      document.querySelector('.product__media');

    if (mediaWrapper) {
      var obs = new MutationObserver(update);
      obs.observe(mediaWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'class', 'data-media-id'],
      });
    }

    // Also respond to variant changes explicitly
    document.addEventListener('variant:changed', update);
  }

  /* ----------------------------------------
   * Init
   * ---------------------------------------- */
  function init() {
    wireButtons();
    syncPrice();
    syncThumb();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
